import * as Sentry from '@sentry/nextjs';
import { SAFE_SENTRY_CAPTURE_TAG } from '@/lib/sentry-scrub';
import type { ProgramNavigationHint } from './program-navigation-hint';

/** One event per rendered hint, never attach the hint object or any binding. */
export function recordProgramNavigationHintRender(hint: ProgramNavigationHint): void {
  Sentry.withScope((scope) => {
    // Match safe operational capture conventions: beforeSend removes request,
    // user and breadcrumbs. No pathname, free text, identity or revisions.
    scope.clear();
    scope.setTag(SAFE_SENTRY_CAPTURE_TAG, 'true');
    scope.setTag('route_class', 'program_navigation_hint');
    scope.setContext('program_navigation_hint', {
      kind: hint.kind,
      family: hint.targets.map((target) => target.family),
    });
    // Use an event allowlist as well: inherited isolation/global context must
    // never reattach a user, tenant, request URL or breadcrumbs to this event.
    scope.addEventProcessor((event) => ({
      event_id: event.event_id,
      timestamp: event.timestamp,
      level: 'info',
      message: 'program_navigation_hint',
      tags: { [SAFE_SENTRY_CAPTURE_TAG]: 'true', route_class: 'program_navigation_hint' },
      contexts: {
        program_navigation_hint: {
          kind: hint.kind,
          family: hint.targets.map((target) => target.family),
        },
      },
      request: { url: 'app://program-navigation-hint' },
    }));
    Sentry.captureMessage('program_navigation_hint', 'info');
  });
}
